



























































import Vue from "vue";
import { Logo } from "../../interfaces";
import { getAvailableLogos } from "../../services";
import LogoForm from "./LogoForm.vue";
export default Vue.extend({
  components: {
    LogoForm,
  },
  data: () => ({
    itemsPerPage: 10,
    page: 1,
    searchText: "",
    logos: [] as any,
    logoForDialog: {},
    showLogoDialog: false,
  }),
  async created() {
    this.logos = await getAvailableLogos();
  },
  methods: {
    async closeLogoDialog(updateLogos: boolean) {
      if (updateLogos) {
        this.logos = await getAvailableLogos(true);
      }
      this.showLogoDialog = false;
    },
    openLogoDialog(logo?: Logo) {
      if (logo) {
        this.logoForDialog = { ...logo };
      } else {
        this.logoForDialog = {};
      }
      this.showLogoDialog = true;
    },
  },
});
